import { useMemo } from 'react';
import { getPaymentWizardFieldImage, getProgressInPercentage } from '../payment-wizard-model';
import Image from '../../../../components/image/Image';
import styles from './PaymentProgressHeader.module.less';

export const PaymentProgressHeader = ({ currentField, wizardFields, wizardType }) => {
    const imageUrl = useMemo(() => getPaymentWizardFieldImage(currentField, wizardType), [currentField, wizardType]);
    const initialProgress = 2.5;
    const progressInPercentage = useMemo(
        () => Math.max(getProgressInPercentage(currentField, wizardFields), initialProgress),
        [currentField, wizardFields]
    );

    return (
        <>
            <Image className={styles.image} src={imageUrl} alt={''} />
            <div className={styles.progressBarContainer}>
                <div style={{ width: `${progressInPercentage}%` }} className={styles.progressBar} />
            </div>
        </>
    );
};
